"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = set;
exports.reset = reset;
exports.get = get;
exports.getById = getById;
exports.getTestAttributes = getTestAttributes;
exports.withTheme = withTheme;
exports.setLogger = setLogger;
exports.withDeprecation = withDeprecation;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.assign"));

var _lodash2 = _interopRequireDefault(require("lodash.clonedeep"));

var _lodash3 = _interopRequireDefault(require("lodash.isfunction"));

var _lodash4 = _interopRequireDefault(require("lodash.isobject"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var constants = _interopRequireWildcard(require("@8x8/oxygen-constants"));

var _oxygenUtils = require("@8x8/oxygen-utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var configObject = (0, _lodash2["default"])(constants);
var logger = console.warn; // eslint-disable-line no-console

var COMPONENT_TYPE_HOC = 'HOC';
/**
 * Extend the default theme with custom configuration.
 * @param {Object} newConfigs
 */

function set(newConfigs) {
  for (var configName in newConfigs) {
    if (!Object.prototype.hasOwnProperty.call(newConfigs, configName)) {
      continue;
    }

    if ((0, _lodash4["default"])(configObject[configName]) && (0, _lodash4["default"])(newConfigs[configName])) {
      configObject[configName] = (0, _lodash["default"])(configObject[configName], newConfigs[configName]);
      continue;
    }

    configObject[configName] = newConfigs[configName];
  }
}
/**
 * Reset the configuration to use the default values for all components
 */


function reset() {
  configObject = (0, _lodash2["default"])(constants);
}
/**
 * Get the full theme configuration
 * @return {Object}
 */


function get() {
  return (0, _lodash2["default"])(configObject);
}
/**
 * Get the configuration for a component/element by ID
 * @param {String} configId
 * @return {*}
 */


function getById(configId) {
  return (0, _lodash2["default"])(configObject[configId]);
}
/**
 * Get the test attributes object
 * @param getTestIdFn
 * @return {Object}
 */


function getTestAttributes(getTestIdFn) {
  return {
    'test-id': getTestIdFn,
    'data-test-id': getTestIdFn,
    'data-id': getTestIdFn
  };
}
/**
 *
 * @param {Class|Function} Component
 * @param {String} configProp Property name of configuration object
 */


function withTheme(Component, configProp) {
  var WithTheme = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    var theme = props.theme,
        rest = _objectWithoutProperties(props, ["theme"]);

    var componentTheme = Object.assign({}, getById(configProp), theme);
    var refs = Component.componentType === COMPONENT_TYPE_HOC ? {
      ref: ref
    } : {
      forwardedRef: ref
    };
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, rest, {
      theme: componentTheme
    }, refs));
  });

  WithTheme.name = Component.name;
  WithTheme.componentType = COMPONENT_TYPE_HOC;
  WithTheme.propTypes = {
    theme: _propTypes["default"].object
  };
  WithTheme.defaultProps = {
    theme: {}
  };
  (0, _hoistNonReactStatics["default"])(WithTheme, Component);
  return WithTheme;
}

function setLogger(newLogger) {
  if ((0, _lodash3["default"])(newLogger)) {
    logger = newLogger;
  }
}

function withDeprecation(Component, deprecationMessage) {
  var WithDeprecation = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    var refs = Component.componentType === COMPONENT_TYPE_HOC ? {
      ref: ref
    } : {
      forwardedRef: ref
    };
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, refs));
  });

  WithDeprecation.componentType = COMPONENT_TYPE_HOC;

  if ((0, _oxygenUtils.isReactDevMode)()) {
    var message = deprecationMessage || "Component \"".concat(Component.displayName || Component.name || '', "\" is deprecated");
    logger("".concat(message, "; Please check Oxygen changelog for more info: https://oxygen.8x8.dev"));
  }

  (0, _hoistNonReactStatics["default"])(WithDeprecation, Component);
  return WithDeprecation;
}